import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import ErrorNotFound from './ErrorNotFound';
import NeelanPage from './NeelanPage';
import WidgetsOnly from './WidgetsOnly';
import NewDemo from './NewDemo';
import RootWrapper from './RootWrapper';
import WriteFeedback from './snippet/WriteFeedback';


const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/view/508587d1-347c-46c3-9f45-183db8bc4fbb" />} />
          <Route path="/iniframe" element={<RootWrapper />} />
          <Route path="/neelan" element={<NeelanPage />} />
          <Route path="/widgets" element={<WidgetsOnly activeTheme="yellow" clientName="apparel" />} />
          <Route path="/view/:viewid" element={<NewDemo />} />
          <Route path="page/write-feedback/:language" element={<WriteFeedback />} />
          <Route path="*" element={<ErrorNotFound />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;